export default function($scope, $sce, $timeout, $anchorScroll, $filter, Api, Restangular, FlashService, user, states, licences, purchase, active_licences) {

    $scope.licences_pro = [];
    $scope.licences_vr = [];
    $scope.licences_gold = [];
    $scope.scroll = $anchorScroll;

    $scope.has_company = GetData().currentUser.company;
    $scope.user = user;
    $scope.states = states;
    $scope.iban = Api.IBAN;

    $scope.image_path = Api.IMAGES + 'uploads/products/';

    if (purchase.id) {
        $scope.purchase = purchase;
        $scope.show_only = purchase.product.type
    }
    else
        $scope.show_only = purchase;

    $scope.licences = licences;

    active_licences.forEach(function (licence, index) {
        if (licence.type == 'vr') {
            $scope.licences_vr.push(licence);
        }
        if (licence.type == 'pro') {
            $scope.licences_pro.push(licence);
        }
        if (licence.type == 'gold') {
            $scope.licences_gold.push(licence);
        }
    });

    $scope.gotoAnchor = function (x) {
        $timeout(function () {
            $anchorScroll($scope.show_only);
        }, 1);
    }

    $scope.types = {
        'licence': {
            name: 'LICENCES'
        }
    };

    $scope.translate = function (text) {
        return $filter('translate')(text);
    }
};


/** WEBPACK FOOTER **
 ** ./js/theme/purchase_licence/controller.js
 **/